import type { HomeDashboardWorkOrderStatusShare } from "../../../../../../../api/kehrblatt/home-dashboard"
import {
  filterSelectableOrganizationUsers,
  type OrganizationUserActivity,
} from "../../../../../_shared/_logic/organization-users"

type PermissionReader = {
  allows: (key: string, level: "view" | "manage") => boolean
}

export const resolveHomeDashboardAccess = (permissions: PermissionReader) => {
  const canViewScheduling =
    permissions.allows("termin.scheduling", "view") ||
    permissions.allows("termin.scheduling", "manage")

  return {
    canViewScheduling,
    canViewDashboard: canViewScheduling,
    canUseOperationalPlanning: permissions.allows("termin.scheduling", "manage"),
  }
}

export const hasActivePlanningEmployee = (
  users: OrganizationUserActivity[] | null | undefined,
  allowedEmployeeIds: string[] | null | undefined,
): boolean => filterSelectableOrganizationUsers(users, allowedEmployeeIds).length > 0

const toDateInputValue = (date: Date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")

  return `${year}-${month}-${day}`
}

export const currentWeekRange = (now = new Date()) => {
  const start = new Date(now)
  start.setHours(0, 0, 0, 0)
  const day = start.getDay()
  const mondayOffset = day === 0 ? -6 : 1 - day
  start.setDate(start.getDate() + mondayOffset)

  const end = new Date(start)
  end.setDate(start.getDate() + 6)

  return {
    startDate: toDateInputValue(start),
    endDate: toDateInputValue(end),
  }
}

export const formatDashboardDay = (value: string) => {
  const date = new Date(`${value}T00:00:00`)

  if (Number.isNaN(date.getTime())) return value

  return date.toLocaleDateString("de-DE", { weekday: "short", day: "2-digit" })
}

export const hasActiveWorkOrderStatusShare = (rows: HomeDashboardWorkOrderStatusShare[]) =>
  rows.some((row) => Number(row.count ?? 0) > 0)
